import type { ChangeEvent, ReactNode } from 'react';

import type { FlexibilityOption } from '@/interfaces';

interface Props {
    values: FlexibilityOption[];
    value: string | number;
    onChange: (value: string) => void;
    className?: string;
}

export const FlexibleDateHandler = ({ value, onChange, values, className }: Props) => (
    <div className={`grid__unit u-display-inline-block ${className}`}>
        <label htmlFor="flexible-date">Velg fleksibilitet:</label>
        <div className="input--select__wrap ">
            <select
                id="flexible-date"
                data-testid="flexible-date"
                aria-label="Velg fleksibilitet"
                value={value}
                onChange={(event: ChangeEvent<HTMLSelectElement>): void => onChange(event.target.value)}>
                {values.map(
                    (item, idx): ReactNode => (
                        // biome-ignore lint/suspicious/noArrayIndexKey: This was set before biome was added
                        <option key={`flexible-date${idx}`} value={item.value}>
                            {item.text}
                        </option>
                    ),
                )}
            </select>
        </div>
    </div>
);
